export default "__VITE_ASSET__B6dbQl5x__"